import { css, styled } from '@mui/material';
import ButtonContainer from '../../components/ButtonContainer';

export const StyledUserClaimsSlideGroupContainer = styled('div')`
  position: relative;
  min-height: 20rem;
`;

export const StyledNotificationsContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};

    & > div:last-of-type {
      margin-bottom: ${theme.spacing('2XL')};
    }

    ${theme.breakpoints.up('desktop')} {
      & > div:last-of-type {
        margin-bottom: ${theme.spacing('6XL')};
      }
    }
  `
);

export const StyledClaimsPageButtonContainer = styled(ButtonContainer)(
  ({ theme }) => css`
    margin-bottom: ${theme.spacing('1XL')};
  `
);

export const StyledUserClaimsList = styled('ul')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    list-style-type: none;
    padding: 0;
    row-gap: ${theme.spacing('LARGE')};
  `
);
